import type {
  DispatchProps,
  OwnProps,
  StateProps,
} from 'components/common-form/sidePanel/status/quoting/Quoting.connect';
import { connect } from 'react-redux';
import { addonQuoteCancelled } from 'state/addonForm/addonForm.action';
import { addonSelector } from 'state/selectors';
import { isQuoteAcked } from 'state/selectors/common/commonForm';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const quoteId = addonSelector.getLastQuoteId(state, tabId);
  const quoteResult = addonSelector.getQuoteResult(state, quoteId);
  const quoteInfos = addonSelector.getQuoteInfo(state, tabId);
  const solvingMode = addonSelector.getSolveFor(state, tabId);

  return {
    quoteRequestStartingTimeInMillis: quoteInfos!.quoteRequestStartingTimeInMillis!,
    estimatedQuotingDurationInMillis: quoteResult?.estimatedQuotingDurationInMillis!,
    isTradable: true,
    solvingMode,
    isQuoteAcked: isQuoteAcked(state, 'postTrade', tabId),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onQuoteCancelled() {
    dispatch(addonQuoteCancelled(tabId));
  },
});

export const connectQuoting = connect(mapStateToProps, mapDispatchToProps);
